<template>
	<div class="modal">
		<div class="modal__container">
			<div class="company">
				<div class="header">
					<div :class="'rating-'+ caixaBaixa(solicitacao.Score)" class="p-relative p-r-60 p-575-r-70">
						<img src="/static/assets/images/selo-garantia.png" class="selo-garantia-bndes" title="Oportunidade com garantia pelo tomador e indicada pelo canal BNDES" v-if="solicitacao.Garantia == 'Sim'">
						<div class="header__title rating">
							{{solicitacao.Empresa.NomeFantasia}}
							<span class="header__title__bullet bullet"></span>
							<span class="header__title__score score">{{solicitacao.Score}}</span>
						</div>
					</div>
					<div>
						<small class="header__id">
							<strong>
								ID#{{ajustIdOportunidade(solicitacao.IdOportunidade,5)}}
							</strong>
							{{formatarTipoEmprestimo(solicitacao.TipoEmprestimo)}}
						</small>
					</div>
					<div class="header__box">
						<div class="header__box__info">
							<span>Cidade/UF: <span class="header__box__value">{{cidadeUf(solicitacao.Empresa.Endereco)}}</span></span>
						</div>
						<div class="header__box__info">
							<span>
								<img src="/static/assets/images/ico_investidores.svg" alt="Icone investidor">
								<span class="header__box__value">{{solicitacao.QuantidadeReservasInvestimento}} Investidores</span>
							</span>
						</div>
					</div>
				</div>
				<Simulation
					:valor="valor"
					:solicitacao="solicitacao"
				/>
			</div>
			<!-- menu direita -->
			<div class="investment">
				<div class="btn">
					<a class="btn__exit" @click="$emit('close', alterado)">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="-8748.215 -19729.99 17.204 17.205">
							<g id="Group_284" data-name="Group 284" transform="translate(-8748.225 -19730)">
								<line id="Line_57" data-name="Line 57" class="cls-1" x1="15.224" y2="15.224" transform="translate(1 1)"/>
								<line id="Line_58" data-name="Line 58" class="cls-1" x1="15.224" y1="15.224" transform="translate(1 1)"/>
							</g>
						</svg>
					</a>
				</div>
				<div class="info">
					<div class="info__values">
						<div>
							<small>Valor Solicitado</small>
							<span>{{formataValor(solicitacao.Valor)}}</span>
						</div>
						<div>
							<small>Valor total do empréstimo</small>
							<span>{{totalEmprestimos}}</span>
						</div>
					</div>
					<div class="info__values">
						<div>
							<small>Valor da parcela</small>
							<span>{{formataValor(solicitacao.ValorParcela)}}</span>
						</div>
						<div>
							<small>Duração esperada</small>
							<span class="info bold" v-if="solicitacao.PrazoDias > 1">{{solicitacao.PrazoDias}} dias</span>
							<span class="info bold" v-else>{{solicitacao.Prazo}} meses</span>
							<!-- <span>{{solicitacao.Prazo}} meses</span> -->
						</div>
					</div>
					<div v-if="verificaProduto(solicitacao.CodProduto)" class="info__percentage">
						<div class="info__percentage__values">
							<div>
								<small>Retorno Bruto Anual</small>
								<span>{{solicitacao.RetornoBrutoAnual}}% a.a.</span>
							</div>
							<div>
								<small>Retorno Bruto Mensal</small>
								<span>{{solicitacao.RetornoBrutoMensal}}% a.m.</span>
							</div>
							<div>
								<small>Retorno Estimado Anual</small>
								<span>{{CDI}}% CDI</span>
							</div>
						</div>
						<div class="info__percentage__footer">
							<small>* A taxa de juros acima é igual ao seu Retorno Bruto <br/> (Retorno antes do desconto de IR).</small>
						</div>
					</div>
					<div v-else class="info__percentage">
						<div class="info__percentage__values">
							<div v-if="!this.antecipacaoGambiarra">
								<small>Retorno Líquido Anual</small>
								<span>{{solicitacao.RetornoBrutoAnual}}% a.a.</span>
							</div>
							<div v-if="this.antecipacaoGambiarra">
								<small>Retorno Bruto final do período</small>
								<span>{{this.taxaGambiarra}}%</span>
							</div>	
							<div v-else>
								<small>Retorno Líquido Mensal</small>
								<span>{{solicitacao.RetornoBrutoMensal}}% a.m.</span>
							</div>
							<div v-if="this.antecipacaoGambiarra">
								<small>Retorno Esperado no período</small>
								<span>{{this.CDIGambiarra}}% CDI</span>
							</div>
							<div v-else>
								<small>Retorno Estimado Anual</small>
								<span>{{CDI}}% CDI</span>
							</div>
						</div>
						<div class="info__percentage__footer" v-if="!this.antecipacaoGambiarra">
							<small>* A taxa de juros acima já é líquida de Imposto de Renda.</small>
						</div>
					</div>
				</div>
				<div class="gathered">
					<div class="gathered__header">
						<span>Levantado: {{formataPorcentagem(solicitacao.Valor, solicitacao.ValorCaptado, solicitacao.ChamadaListaEspera)}}%</span>
						<span>Faltam:
							<strong>{{valorRestante(solicitacao.Valor, solicitacao.ValorCaptado, solicitacao.ChamadaListaEspera)}}</strong>
						</span>
					</div>
					<div class="gathered__bar">
						<div class="gathered__bar__progress" :style="'width: '+formataPorcentagem(solicitacao.Valor, solicitacao.ValorCaptado, solicitacao.ChamadaListaEspera)+'%'"></div>
						<span class="gathered__bar__value">{{formataPorcentagem(solicitacao.Valor, solicitacao.ValorCaptado, solicitacao.ChamadaListaEspera)}} %</span>
					</div>
					<div class="gathered__info">
						<span>Início da captação:
							<strong>{{formataData(solicitacao.InicioCaptacao, true)}}</strong>
						</span>
						<span>Expira em:
							<strong>{{formataData(solicitacao.FimCaptacao, true)}}</strong>
						</span>
					</div>
				</div>
				<Investment
					:solicitacao="solicitacao"
					:investidor="investidor"
					:usuario="usuario"
					:valorInicial="valorInicial"
					@updateSolicitacao="(solicitacao)=>AtualizaSolicitacao(solicitacao)"
					@updateValor="(valor)=>AtualizaValor(valor)"
					@close="(alterado)=>$emit('close', alterado)"
				/>
			</div>
		</div>
	</div>
</template>

<script>
	import * as mutationTypes from '@/store/mutation-types.js'
    import ApiClient from '../../utils/api-client'
	import Masker from '../../utils/masker'
    import DateHelper from '../../utils/date-helper'
	import Simulation from './Simulation'
	import Investment from './Investment'
	
	export default {
		data() {
			return {
				valor:'0',
				alterado:false,
				solicitacao:this.solicitacaoProps,
				antecipacaoGambiarra: false, 
				taxaGambiarra: 5.26,
				CDIGambiarra: 641.46
			}
		},
		components:{
			Simulation,
			Investment,
		},
		props:{
			valorInicial: { type: String },
			solicitacaoProps:{ type: Object },
			investidor:{ type: Object },
			usuario:{ type: Object },
		},
		computed:{
            totalEmprestimos(){
                return this.formataValor(this.solicitacao.Prazo * Math.floor(this.solicitacao.ValorParcela*100)/100)
            },
			CDI(){
				return this.solicitacao.CDI != undefined ? this.solicitacao.CDI : this.solicitacao.Cdi
			}
        },
		methods:{
				verificaProduto(produto) {
					
					if(produto != "EMPRES") {
						return true
					}

					return false
				},
			// Ação
				AtualizaSolicitacao(atualizacao){
					this.alterado = true
					this.solicitacao = atualizacao
				},
				AtualizaValor(valor){
					this.valor = valor
				},
			// Metodos de formatacao
				caixaBaixa(texto) {
					if (texto == null || texto == undefined) return "";

					if (texto == "AA" || texto == "HR") return texto.toLowerCase();

					return texto.substr(0, 1).toLowerCase();
				},
				formataPorcentagem(valor, valorCaptado, listaEspera){
					// confere se solicitacao está em lista de espera
					listaEspera ? valorCaptado = valor : ''
					return (valorCaptado*100/valor).toFixed(2)
				},
				valorRestante(valor, reservado, listaEspera){
					let valorAdequado = (valor-reservado)*100
					return listaEspera ? 'R$ 0,00' : 'R$ ' + Masker.maskMoney(valorAdequado.toString()) 
				},
				formataValor(valor){
					let valorAdequado = ((valor)*100).toFixed()
					return 'R$ ' + Masker.maskMoney(valorAdequado.toString())
				},
				formataData(data){
					return DateHelper.formataDataString(data)
				},
				cidadeUf(endereco){
					return endereco.Cidade + ' / ' + endereco.Uf
				},
				ajustIdOportunidade(id, qtd) {
					var s = String(id);
					while (s.length < (qtd || 2)) {
						s = "0" + s;
					}
					return s;
				},
				formatarTipoEmprestimo(tipoEmprestimo) {

					if (tipoEmprestimo.toLowerCase() == "emprestimo-de-impacto2") {
						return "Impacto";
					}

					let splitedTipoEmprestimo = tipoEmprestimo.split('-');

					if (splitedTipoEmprestimo.length > 1) {
						if (splitedTipoEmprestimo[1] == "ccb")
							return splitedTipoEmprestimo[1].toUpperCase();

						return splitedTipoEmprestimo[1][0].toUpperCase() + splitedTipoEmprestimo[1].substr(1);
					}

					return tipoEmprestimo[0].toUpperCase() + tipoEmprestimo.substr(1);
				},
		},
		created(){
			if(this.solicitacaoProps._id === "5e9de72f796877415093cb1d" || this.solicitacaoProps._id === "5ea348604e46501f80f6641f") this.antecipacaoGambiarra = true;
		}
	}
</script>

<style lang="scss" scoped>

	@import "../../assets/styles/iouu/variables";
	@import "../../assets/styles/iouu/mixins";

	.modal {
		position: fixed;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 999999999!important;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, .80);
		transition: opacity .3s ease;
		overflow-x: hidden;
		overflow-y: auto;
		font-family: "Helvetica-Neue";

		@include xs {
			align-items: flex-start;
			background-color: #fff;
			height: 100%;
		}

		&__container {
			position: relative;
			width: 1340px;
			margin: 0px auto;
			background-color: #fff;
			border-radius: 5px;
			box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
			transition: all .3s ease;
			font-family: Helvetica, Arial, sans-serif;
			display: flex;
			flex-direction: row;
			@include xs {
				flex-direction: column;
				left:0px;
				top:0px;
				right: 0px;
				bottom: 0px;
				width: 100%;
				margin: 0px;
				border-radius: 0px;
				box-shadow: none;
			}
		}
	}

	.btn{
		&__exit {
			position: absolute;
			top: 12px;
			right: 12px;
			
			& > svg {
				width: 12px;
			}

			.cls-1 {
				fill: none;
				stroke: #41D3BD;
				stroke-linecap: round;
				stroke-linejoin: round;
				stroke-miterlimit: 10;
				stroke-width: 1.4px;
			}
		}
	}

	small{
		font-size:10px;
	}

	// Interface da lateral da empresa
	.company {
		flex:2;
		flex-direction: column;
		border-radius: 5px 0px 0px 5px;
		border-right: none;
		padding:15px 25px;
		padding-bottom: 0;
	}

	.header{
		flex-direction: row;

		&__title{
			font-size: 22px;
			display:inline-flex;

			&__bullet{
				margin-left: 10px;
				margin-right: 5px;
			}

			&__score{
				color:#95989A;
				font-size: 16px;
			}
		}
		
		&__id{
			font-size:13px;
			color:#999999;

			& > strong{
				color:#999999;
			}
		}

		&__box{
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			justify-content: space-between;
			margin: 8px 0px;

			&__info{
				color:#999999;
				font-size: 14px;
				width: 49%;
				min-width: 315px;
				padding:8px;
				margin-bottom: 8px;
				border-radius: 5px;
				border: 1px solid #ddd;
				display: inline-block;

				& > span > img{
					width: 22px;
				}
			}
			&__value{
				color: #000;
				font-weight: bold;
			}
		}
	}

	// Interface da lateral de investimento
	.investment {
		flex:1;
		flex-direction: column;
		border-radius: 0px 5px 5px 0px;
		border-left: 1px solid #ccc;
		padding:15px;
		padding-top:0px;
	}

	.info{
		display: flex;
		flex-direction:column;

		&__values{
			flex:1;
			display: flex;
			justify-content: space-around;
			border-bottom: 1px solid #ddd;

			& > div{
				flex:1;
				display: flex;
				margin: 8px 0px;
				text-align: center;
    			flex-direction: column;

				&:first-child{
					border-right: 1px solid #ddd;
				}

				& > small{
					color:#888888;
					font-weight: bold;
				}

				& > span{
					font-size: 18px;
					font-weight: bold;
				}
			}
		}
		&__percentage{

			display: flex;
			flex-direction:column;
			padding-bottom: 15px;
			border-bottom: 1px solid #ddd;

			&__values{
				flex:1;
				display: flex;
				justify-content: space-around;

				& > div{
					flex:1;
					display: flex;
					margin-top: 15px;
					margin-bottom: 10px;
					text-align: center;
					flex-direction: column;

					& > small{
						color:#888888;
						font-weight: bold;
					}

					& > span{
						font-size: 20px;
						font-weight: bold;
					}
				}
			}

			&__footer{
				margin: 0px 90px;
				line-height: 0.8;
				text-align: center;
				color: #999;

				& > small{
					font-size: 10px;
				}
			}
		}
	}

	.gathered{
		// display:flex;
		font-size: 11px;
		padding:8px 0px;
		flex-direction: column;
		border-bottom: 1px solid #ddd;

		&__header{
			display:flex;
			color:#666666;
			justify-content: space-between;
		}

		&__bar{
			font-size: 11px;
			display: flex;
			align-items: center;
			height: 18px;
			background-color: #ccc;
			margin:10px 0px;
			border-radius: 10px;
			position:relative;
			&__progress{
				height: 100%;
				border-radius: 10px;
				background-color: #41D3BD;
			}
			&__value{
				width: 100%;
				font-weight: bold;
				display: inline-block;
				position:absolute;
				text-align: center;
			}
		}
		&__info{
			display: flex;
			color:#666666;
			flex-direction: column;
			& > span > strong{
				color:#000;
			}
		}
	}

	.p-relative {
		position: relative;
	}

	.selo-garantia-bndes {
		cursor:pointer;
		position: absolute;
		top: -15px;
		right: -20px;
		height: 80px;
	}

	.selo-bndes {
		cursor: pointer;
		position: absolute;
		top: -20px;
		right: -20px;
		height: 70px;
	}

	.p-r-60 {
		padding-right: 60px;
	}

	@media only screen and (max-width: 575px) {
		.selo-garantia-bndes {
	    	right: 10px;
			height: 80px
		}

		.p-575-r-70 {
			padding-right: 70px;
		}

		.selo-bndes {
	    	right: 10px;
			height: 60px
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/NewModal/Modal.vue